import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-[#0a0a0f]/95 backdrop-blur-xl border-b border-white/10 shadow-lg shadow-black/40'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollTo('hero')}>
          <img
            src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/caaea5a1b17e64d200d3c08d14d4a01f.png"
            alt="Nova Güzellik Lounge"
            className="h-10 md:h-12 w-auto object-contain"
          />
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6 text-sm font-medium">
          {[
            { label: 'Nasıl Çalışır', id: 'nasil-calisir' },
            { label: 'Kampanyalar', id: 'kampanyalar' },
            { label: 'Panel', id: 'yonetim-paneli' },
            { label: 'Reklam', id: 'reklam-siparis' },
            { label: 'İletişim', id: 'iletisim' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/70 hover:text-[#d4af37] transition-colors duration-200 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
        </div>

        {/* Desktop CTAs */}
        <div className="hidden md:flex items-center gap-3">
          <button
            onClick={() => scrollTo('kampanyalar')}
            className="px-5 py-2.5 rounded-full border border-[#00d9ff]/60 text-[#00d9ff] text-sm font-semibold hover:bg-[#00d9ff]/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Kampanyaları İncele
          </button>
          <a
            href="https://wa.me/905001234567?text=Merhaba%2C%20kampanyalar%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
            target="_blank"
            rel="noopener noreferrer"
            className="px-5 py-2.5 rounded-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black text-sm font-bold hover:opacity-90 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            WhatsApp&apos;tan Yaz
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center text-white cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0a0a0f]/98 backdrop-blur-xl border-t border-white/10 px-4 py-6 flex flex-col gap-4">
          {[
            { label: 'Nasıl Çalışır', id: 'nasil-calisir' },
            { label: 'Kampanyalar', id: 'kampanyalar' },
            { label: 'Yönetim Paneli', id: 'yonetim-paneli' },
            { label: 'Reklam Modülü', id: 'reklam-siparis' },
            { label: 'İletişim', id: 'iletisim' },
          ].map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-white/80 text-base font-medium text-left py-2 border-b border-white/5 cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <div className="flex flex-col gap-3 pt-2">
            <button
              onClick={() => scrollTo('kampanyalar')}
              className="w-full py-3 rounded-full border border-[#00d9ff]/60 text-[#00d9ff] text-sm font-semibold cursor-pointer whitespace-nowrap"
            >
              Kampanyaları İncele
            </button>
            <a
              href="https://wa.me/905001234567?text=Merhaba%2C%20kampanyalar%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum."
              target="_blank"
              rel="noopener noreferrer"
              className="w-full py-3 rounded-full bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black text-sm font-bold text-center cursor-pointer whitespace-nowrap"
            >
              WhatsApp&apos;tan Yaz
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
